<template>
  <article class="project-box">
    <div>
      <router-link :to="link" class="project-box__photo-wrap">
        <div
          :style="{ backgroundImage: `url(${ photo })` }"
          class="project-box__photo"
        />
        <plus-icon class="project-box__photo-plus"/>
      </router-link>
      <h2><router-link :to="link" v-html="title" class="project-box__link"/></h2>
    </div>
  </article>
</template>

<script>
import PlusIcon from '@/components/PlusIcon'

export default {
  components: {
    PlusIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    photo: {
      type: String,
      default: ''
    },
    link: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
  .project-box {
    @include equal-height-column;
    @include vertical-space((bottom: 2), padding);

    &__photo-wrap {
      @include vertical-space((bottom: 1), margin);
      @include reset-link;
      display: block;
      height: 16 * $vertical-space;
      margin-top: 17px;
      overflow: hidden;
      position: relative;

    }
    &__photo-plus {
      @include center-self(absolute);
      height: 100px;
      width: 100px;
      opacity: 0;
      transition: opacity .3s;
    }

    &__photo-wrap:hover &__photo-plus {
      opacity: 1;
    }

    &__photo {
      @include cover-background;
      width: 100%;
      height: 100%;

      transition: transform .4s;
    }

    &__photo-wrap:hover &__photo {
      transform: scale(1.05);
    }

    &__link {
      @include reset-link;
      transition: color $base-transition;

      &:hover {
        @include theme-opposite(color);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Projects/ProjectBox.vue